module.exports = __webpack_public_path__ + "img/IMG_2368_L_WoodMatted.46cc40b3.jpg";